import React from 'react';
import { BackButton } from './BackButton';

import './common.css';

export interface DetailToolbarProps {
  /** Title displayed in the toolbar. */
  title: string;
  /** Handler for the back button. If omitted, no back button is shown. */
  onBack?: () => void;
  /** Back button aria-label (defaults to "Back"). */
  backLabel?: string;
  /** Optional actions rendered on the right side of the toolbar. */
  actions?: React.ReactNode;
}

/**
 * Shared detail-view toolbar: [Back] [Title] ... [Actions].
 *
 * Replaces `stats-preview-toolbar`, `eval-detail-toolbar`, etc.
 */
export const DetailToolbar: React.FC<DetailToolbarProps> = ({
  title,
  onBack,
  backLabel,
  actions,
}) => (
  <div className="detail-toolbar">
    <div className="detail-toolbar-left">
      {onBack && <BackButton onPress={onBack} aria-label={backLabel} />}
      {onBack && <span className="detail-toolbar-divider" aria-hidden="true" />}
      <span className="detail-toolbar-title" title={title}>{title}</span>
    </div>
    {actions && <div className="detail-toolbar-actions">{actions}</div>}
  </div>
);
